import { Component } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-configurator-sub-menu',
  templateUrl: './configurator-sub-menu.component.html',
  styleUrls: ['./configurator-sub-menu.component.css'],
})
export class ConfiguratorSubMenuComponent {
  expandedMenuName = '';

subMenuItems: any = [];

  route = '';
  constructor(
    public router: Router,

    public activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const spl = this.router.url.split('/');
        this.route = spl[spl.length - 1];

        this.subMenuItems.forEach((item:any) => {
          item.subMenu?.forEach((i: any) => {
            if (i.route === this.route) {
              this.expandedMenuName = item.route;
            }
          });
        });

        console.log(this.expandedMenuName);
      });

      setTimeout(() => {
        let self = this;
        self.getSubMenu();
      let categoriesMenu = JSON.parse(localStorage.getItem('navigations') as any);
      console.log(categoriesMenu)
      
      self.subMenuItems = this.subMenuItems.filter(
        (item: any) => {
          let titleForList = item.name.toLowerCase().split(' ').join('-');
          return categoriesMenu.includes(titleForList)
        }
      );
      for(let i = 0; i <= self.subMenuItems.length;i++) {
        let titleForList = self.subMenuItems[i].name.toLowerCase().split(' ').join('-');
        if(categoriesMenu.includes(titleForList)) {
          console.log(titleForList)
          this.router.navigate([`home/configurator/${self.subMenuItems[i].route}`]);
          break;
        }
      }
      console.log(self.subMenuItems);
    },0)
    

  }

  getSubMenu() {
    this.subMenuItems = [
      {
        image: '',
        name: 'Pricing',
        hasSubMenu: true,
        route: 'pricing',
        subMenu: [
          {
            image: '',
            name: 'Scheme Manager',
            route: 'schemeManager',
          },
          // {
          //   image: '',
          //   name: 'Calculator',
          //   route: 'calculator',
          // },
        ],
      },
      // {
      //   image: '',
      //   name: 'Business Rules',
      //   route: 'rfj',
      // },
      {
        image: '',
        name: 'Provider',
        route: 'provider',
      },
      // {
      //   image: '',
      //   name: 'Api Manager',
      //   route: 'apiManager',
      // },
    ];
  }
  shouldHighlight(item: (typeof this.subMenuItems)[number]) {
    // return true;
    console.log(this.route, item.subMenu);

    return (item.subMenu?.findIndex((v: any) => v.route === this.route) ?? -1) > 0;
  }
}
